@if(!submitted) {
<section class="" role="main" aria-labelledby="registration-heading">
  @if(isLoader) {
  <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999"
    role="status" aria-live="polite" aria-label="Loading registration">
    <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" aria-label="Loading" />
  </div>
  }
  <app-breadcrumb [items]="['SIGN_UP_BUTTON' | translate]"></app-breadcrumb>

  <div class="px-[7rem] sm:px-[9.6rem]">
    <div class="justify-self-center flex flex-col gap-[4rem] w-full sm:max-w-[124.8rem] mx-auto">
      <div class="flex flex-col gap-[1.6rem]">
        <h1 id="registration-heading" class="dsr-typescale-title-medium">{{ "SIGN_UP_BUTTON" | translate }}</h1>
        <span class="dsr-typescale-body-small">{{ "ACCOUNT_DROP_LABEL" | translate }}</span>
      </div>

      <div class="sm:flex sm:flex-row sm:flex-wrap sm:gap-[2rem] gap-[2rem] sm:justify-start  grid grid-cols-2 border-none">
        @for (accountType of accountTypes; track accountType; let i = $index) {
        <div class="" (click)="onAccountTypeSelect(i, accountType)" [attr.aria-pressed]="selectedAccountTypeIndex == i"
          [attr.aria-label]="'Select ' + (accountType | translate)">
          <app-user-profil-type [accountType]="accountType | translate" [icon]="icons[i]"
            [secLine]="accountTypeSecLines[i] | translate" [description]="accountTypeDescriptions[i] | translate"
            [selected]="selectedAccountTypeIndex == i"></app-user-profil-type>
        </div>
        }
      </div>

      <!-- registration form -->
      @if(selectedAccountTypeIndex != -1) {
      <div>
        <form #registrationForm="ngForm" class="flex flex-col gap-[1.5rem]" role="form" aria-labelledby="form-title">
          <header class="!uppercase flex flex-col gap-[0.8rem]">
            <h2 id="form-title" class="dsr-typescale-label-large-prominent">
              {{ accountTypes[selectedAccountTypeIndex] | translate }} 
              {{ accountTypeSecLines[selectedAccountTypeIndex] == '' ? '' : '- ' + (accountTypeSecLines[selectedAccountTypeIndex] | translate) }}
            </h2>
            <p class="dsr-typescale-body-small-prominent">
              &ast; {{ "FORM_MANDATORY_TEXT" | translate }}
            </p>
          </header>

          <fieldset class="flex flex-col gap-[1.8rem] border-none">
            <legend class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary mb-6">
              {{ "REGISTRATION_LEGEND_PERSONAL" | translate }}
            </legend>

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem] pt-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_FIRSTNAME_LABEL' | translate }}</mat-label>
                <input matInput type="text" placeholder="{{ 'FORM_FIRSTNAME_PLACEHOLDER' | translate }}" ngModel
                  id="firstName" name="firstName" #firstName="ngModel" maxlength="30" required
                  autocomplete="given-name" pattern="^[^0-9]+$" minlength="1" aria-required="true" />
                @if(firstName.errors && firstName.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_FIRSTNAME_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_LASTNAME_LABEL' | translate }}</mat-label>
                <input matInput type="text" placeholder="{{ 'FORM_LASTNAME_PLACEHOLDER' | translate }}" ngModel
                  id="lastName" name="lastName" #lastName="ngModel" maxlength="30" required
                  autocomplete="family-name" pattern="^[^0-9]+$" aria-required="true" />
                @if(!lastName.valid && lastName.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_NAME_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>E-mail</mat-label>
                <input matInput type="email" placeholder="{{ 'FORM_EMAIL_PLACEHOLDER' | translate }}" ngModel
                  id="userMail" name="userMail" #userMail="ngModel" maxlength="60" required autocomplete="email"
                  pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" (focus)="removeEmailError()"
                  aria-required="true" />
                <dsr-icon name="mail"  matSuffix aria-hidden="true"></dsr-icon>
                @if(!userMail.valid && userMail.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_EMAIL_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
          </fieldset>
          @if(selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE){
          <fieldset>
            <div>
              <div role="alert"
                class="flex items-start gap-[1.6rem] p-[1.6rem] mb-[2.4rem] rounded-[0.8rem] border border-solid border-[--dsr-color-warning] bg-[--dsr-color-warning-container] text-[--dsr-color-on-warning-container]" >
                
                <dsr-icon name="alert" size="2.4rem" color="var(--dsr-color-on-warning-container)"
                  aria-hidden="true" />
                <div class="flex flex-col gap-[0.8rem]">
                  <h2 id="technicalCollege-notice" class="dsr-typescale-label-large-prominent">
                    {{ "REGISTRATION_TECHNICAL_COLLEGE_NOTICE_HEAD" | translate }}
                  </h2>
                  <p class="dsr-typescale-body-small text-[--dsr-color-on-warning-container]">
                    {{ "REGISTRATION_TECHNICAL_COLLEGE_NOTICE_BODY" | translate }}
                  </p>
                </div>
              </div>
            <legend class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary mb-6">
              {{ "REGISTRATION_TECHNICAL_COLLEGE_PAYMENT_LEGEND" | translate }}
            </legend>
            <div class="flex gap-6 items-start lg-xl:items-center flex-col lg-xl:flex-row">
              <h2  class="dsr-typescale-body-small">
                {{ "REGISTRATION_TECHNICAL_COLLEGE_PAYMENT_HEAD" | translate }}
              </h2>
              <mat-radio-group aria-labelledby="payment-method" class="flex gap-6" name="paymentMethodForTechnical"
                ngModel #paymentMethodForTechnical="ngModel" required>
                <mat-radio-button disableRipple="true" value="yes" aria-label="I agree">
                  <span class="font-renault-group-bold dsr-typescale-body-small-prominent">
                    {{ "REGISTRATION_TECHNICAL_COLLEGE_PAYMENT_CREDIT" | translate }}</span></mat-radio-button>
                <mat-radio-button value="no" aria-label="I disagree">
                  <span class="font-renault-group-bold dsr-typescale-body-small-prominent">
                    {{ "REGISTRATION_TECHNICAL_COLLEGE_PAYMENT_OTHER" | translate }}</span></mat-radio-button>
                    @if(paymentMethodForTechnical.errors && paymentMethodForTechnical.touched) {<mat-error>
                      {{ 'REGISTRATION_LABEL_PAYMENT_ERROR' | translate }}
                    </mat-error>}
              </mat-radio-group>
            </div>
            
            </div>
          </fieldset>
          }

          <fieldset class="flex flex-col gap-[1.8rem] border-none">
            <legend class="dsr-typescale-label-large-prominent !uppercase text-light-dsr-color-primary mb-6">
              {{ "REGISTRATION_LEGEND_CONTACTS" | translate }}
            </legend>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem] pt-2">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_COMPANY_NAME_LABEL' | translate }}</mat-label>
                <input matInput type="text" placeholder="{{ 'FORM_COMPANY_NAME_PLACEHOLDER' | translate }}" ngModel
                  id="companyName" name="companyName" #companyName="ngModel" maxlength="40" autocomplete="off"
                  required />
                @if(!companyName.valid && companyName.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_COMPANY_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              <div class="sm:col-span-2">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'FORM_ADDRESS_LABEL' | translate }}</mat-label>
                  <input matInput ngModel id="address" placeholder="{{ 'FORM_ADDRESS_PLACEHOLDER' | translate }}"
                    name="address" #address="ngModel" maxlength="100" autocomplete="off"
                    (blur)="checkTextPattern()" required />
                  @if((!address.valid && address.touched) || notValidContent) {
                  <mat-error>{{ 'REGISTRATION_LABEL_ADDRESS_ERROR' | translate }}</mat-error>
                  }
                </mat-form-field>
              </div>

              
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_POSTAL_CODE_LABEL' | translate }}</mat-label>
                <input matInput type="text" ngModel id="postalCode" name="postalCode" #postalCode="ngModel"
                  autocomplete="off" required [maxlength]="countryId === 73 ? 5 : 9"
                  [pattern]="countryId === 73 ? '^\\d{5}$' : '^[a-zA-Z0-9]{1,9}$'" />
                @if(!postalCode.valid && postalCode.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_CODE_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_CITY_LABEL' | translate }}</mat-label>
                <input matInput type="text" ngModel id="state" name="state" #state="ngModel" maxlength="30" required
                  autocomplete="off" minlength="1" pattern="^[A-Za-z- ]+$" />
                @if(!state.valid && state.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_CITY_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_COUNTRY_LABEL' | translate }}</mat-label>
                <mat-select panelClass="profile-option-panel" (selectionChange)="countryChange($event.value)"
                  id="{{ 'FORM_COUNTRY_LABEL' | translate }}" name="selCountryId" [(ngModel)]="countryCode"
                  #selCountryId="ngModel" required aria-required="true">
                  @for (country of countryList; track country) {
                  <mat-option [value]="country.countryCode">{{ country.countryName }}</mat-option>
                  }
                </mat-select>
                <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                  class="pointer-events-none" aria-hidden="true"></dsr-icon>
                @if(!selCountryId.valid && selCountryId.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_COUNTRY_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">

              <div
                class="grid grid-cols-1 sm:grid-cols-[minmax(0,1.2fr)_minmax(0,3.8fr)] gap-[1rem] w-full">
                <div class="min-w-0">
                  <mat-form-field appearance="outline"  floatLabel="always" class="w-full">
                    <mat-label>{{ 'FORM_DIALLING_CODE_LABEL' | translate }}</mat-label>
                    <input matInput type="text" placeholder="{{ 'FORM_DIALLING_CODE_PLACEHOLDER' | translate }}"
                      [(ngModel)]="diallingCode" name="diallingCode" readonly />
                  </mat-form-field>
                </div>
                <div class="min-w-0">
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>{{ 'FORM_PHONE_LABEL' | translate }}</mat-label>
                    <input matInput type="text" placeholder="{{ 'FORM_PHONE_PLACEHOLDER' | translate }}" ngModel
                      id="mobileNumber" class="mobileNumber" name="mobileNumber" #mobileNumber="ngModel"
                      autocomplete="off" required pattern="^(?!\s*$)\d{4,13}$" />
                    @if(!mobileNumber.valid && mobileNumber.touched) {
                    <mat-error>{{ 'REGISTRATION_LABEL_MOBILE_ERROR' | translate }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_LANGUAGE_LABEL' | translate }}</mat-label>
                <mat-select panelClass="profile-option-panel" placeholder="{{ 'FORM_LANGUAGE_PLACEHOLDER' | translate }}" [(ngModel)]="language"
                  id="language" name="language" #languageControl="ngModel" required aria-required="true">
                  @for (lang of languageList; track lang) {
                  <mat-option [value]="lang.langCode">{{ lang.langName }}</mat-option>
                  }
                </mat-select>
                <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                  class="pointer-events-none" aria-hidden="true"></dsr-icon>
                @if(!languageControl.valid && languageControl.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_LANGUAGE_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>

              
              
              @if((selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
              selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER ||
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE &&
              registrationForm.value.paymentMethodForTechnical === 'yes'))) {
              <div class="sm:col-span-1">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'REG_COMPANY_LABEL' | translate }}</mat-label>
                  <input matInput type="text" ngModel id="registerNumber" name="registerNumber"
                    #registerNumber="ngModel"  maxlength="50"
                    minlength="1" required autocomplete="off" />
                  @if(!registerNumber.valid && registerNumber.touched) {
                  <mat-error>{{ 'REG_COMPANY_ERROR' | translate }}</mat-error>
                  }
                </mat-form-field>
              </div>
              }
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
              @if(
              showVatField &&
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
              selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER ||
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE &&
              registrationForm.value.paymentMethodForTechnical === 'yes'))
              ) {
              <div class="flex flex-col gap-[0.8rem]">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>{{ 'REGISTRATION_LABEL_VAT' | translate }}</mat-label>
                  <input matInput type="text" [(ngModel)]="vatValue" id="vatValue" name="vatValue"
                    #vatModel="ngModel" maxlength="15" required autocomplete="off" pattern="^[a-zA-Z0-9]+$"
                    placeholder="{{ 'VAT_PLACEHOLDER' | translate }}" (ngModelChange)="vatNumberChanged()" />
                  <dsr-icon matSuffix [ngClass]="{
                      '!bg-[lawngreen]': vatVerified,
                      '!bg-[#000000]': !vatVerified,
                    }" class="cursor-pointer" [name]="vatVerified ? 'confirm-2' : 'refresh'" alt="VAT verify"
                    (click)="validateVAT()" matTooltip="verify VAT number"></dsr-icon>
                  <mat-hint>{{ 'VAT_SAMPLE' | translate }}</mat-hint>
                  @if(vatModel.errors && vatModel.touched) {
                  <mat-error>{{ 'REGISTRATION_VAT_ERROR' | translate }}</mat-error>
                  }
                </mat-form-field>
                @if(!showVATError) {
                <div class="error-span !text-red-500 !font-[600] dsr-typescale-body-small min-h-[2.2rem] !text-wrap">
                  {{ 'REGISTRATION_VAT_ERROR' | translate }}
                </div>
                }
                @if(!vatValidateError) {
                <div class="error-span">{{ 'VAT_VALIDATE_ERROR' | translate }}</div>
                }
                @if(sirenVatMismatch) {
                <div class="error-span !text-red-500 !font-[600] dsr-typescale-body-small min-h-[2.2rem] !text-wrap">
                  {{ 'REGISTRATION_VAT_SIREN_MISMATCH_ERROR' | translate }}
                </div>
                }
              </div>
              }

              @if(
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
              selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER ||
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE &&
              registrationForm.value.paymentMethodForTechnical === 'yes')) &&
              (countryCode === 'FR' || countryCode === 'GP' || countryCode === 'MQ' || countryCode === 'RE')) {
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>SIREN</mat-label>
                <input matInput type="text" [(ngModel)]="sirenValue" id="siren" name="siren" #siren="ngModel"
                  required autocomplete="off" pattern="^\d{9}$" maxlength="9"
                  (ngModelChange)="checkSirenVatMatch()" />
                @if(!siren.valid && siren.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_SIREN_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              }
              @if(
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
              selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER ||
              (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE &&
              registrationForm.value.paymentMethodForTechnical === 'yes')) &&
              (countryCode === 'FR' || countryCode === 'GP' || countryCode === 'MQ' || countryCode === 'RE')) {
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>SIRET</mat-label>
                <input matInput type="text" ngModel id="siret" name="siret" #siret="ngModel" required (ngModelChange)="appendToEinvoiceValue()"
                  autocomplete="off" pattern="^\d{14}$" maxlength="14" />
                @if(!siret.valid && siret.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_SIRET_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              }
              
            </div>
            @if(
            (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET || 
            (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE && registrationForm.value.paymentMethodForTechnical === 'yes') ||
            selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER) &&
            (countryCode === 'FR' || countryCode === 'GP' || countryCode === 'MQ' || countryCode === 'RE')) {
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-[2.4rem]">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'E-INVOICING_LABEL' | translate }}</mat-label>
                <mat-select panelClass="profile-option-panel" [(ngModel)]="eInvoice" name="eInvoice" id="{{ 'E-INVOICING_LABEL' | translate }}" (selectionChange)="appendToEinvoiceValue()">
                  @for (option of einvoicingList; track option) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
                <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black"
                  class="pointer-events-none" aria-hidden="true"></dsr-icon>
              </mat-form-field>
              @if(eInvoice === 'SRSTRC') {
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'ROUTING_CODE_LABEL' | translate }}</mat-label>
                <input matInput type="text" ngModel id="routingCode" name="routingCode" #routingCode="ngModel"
                  maxlength="30" required minlength="1" aria-required="true" autocomplete="off" (ngModelChange)="appendToEinvoiceValue()"/>
                @if(routingCode.errors && routingCode.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_ROUTING_CODE_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              }
              @if(eInvoice === 'SRSF') {
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'SUFFIX_LABEL' | translate }}</mat-label>
                <input matInput type="text" ngModel id="suffix" name="suffix" #suffix="ngModel"
                  maxlength="30" required minlength="1" aria-required="true" autocomplete="off" (ngModelChange)="appendToEinvoiceValue()"/>
                @if(!suffix.valid && suffix.touched) {
                <mat-error>{{ 'REGISTRATION_LABEL_SUFFIX_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              }
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'E-INVOICE_VALIDATE_LABEL' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="EInvoiceValue" id="einvoiceValue" name="eInvoiceValue"
                  #eInvoiceModel="ngModel" required autocomplete="off" [errorStateMatcher]="noErrorStateMatcher"
                  readonly />
                <dsr-icon matSuffix [ngClass]="{'!bg-[lawngreen]': einvoiceAddressLineVerified, '!bg-[#000000]': !einvoiceAddressLineVerified }"
                  class="cursor-pointer" (click)="validateEinvoiceAddressLine()" [name]="einvoiceAddressLineVerified ? 'confirm-2' : 'refresh'" alt="verify E-Invoice"   
                  matTooltip="verify E-Invoice"></dsr-icon>
                @if(einvoiceAddressLineError && !einvoiceAddressLineVerified) {
                <mat-hint class="!text-red-500 !font-[600] !text-wrap">
                  @switch (eInvoice) {
                    @case ('SRST') { {{ 'EINVOICE_SIREN_SIRET_ERROR' | translate }} }
                    @case ('SRSTRC') { {{ 'EINVOICE_SIREN_SIRET_ROUTING_ERROR' | translate }} }
                    @case ('SRSF') { {{ 'EINVOICE_SIREN_SUFFIX_ERROR' | translate }} }
                    @default { {{ 'EINVOICE_SIREN_ERROR' | translate }} }
                  }
                </mat-hint>
                }
              </mat-form-field>
            </div>
            }
            @if(
            selectedAccountTypeIndex != this.ACCOUNT_TYPE_LABEL3_FLEET &&
            selectedAccountTypeIndex != this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER &&
            selectedAccountTypeIndex != this.ACCOUNT_TYPE_LABEL6_VHU_ICPE
            ) {
            <div class="flex gap-[2.4rem]">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_REQUEST_OBJECT_LABEL' | translate }}</mat-label>
                <textarea matInput ngModel placeholder="{{ 'FORM_REQUEST_OBJECT_PLACEHOLDER' | translate }}"
                  id="message" name="message" #message="ngModel" maxlength="300" rows="4" cols="40"
                  autocomplete="off" (blur)="checkMessageTextPattern()" required></textarea>
                @if((!message.valid && message.touched) || notMessageValidContent) {
                <mat-error>{{ 'REGISTRATION_LABEL_MESSAGE_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if(selectedAccountTypeIndex == this.ACCOUNT_TYPE_LABEL6_VHU_ICPE) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-[2.4rem]">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'FORM_AGREEMENT_LABEL' | translate }}</mat-label>
                <input matInput type="text" ngModel id="agrement" name="agrement" #agrement="ngModel"
                  maxlength="20" required autocomplete="off" pattern="[a-zA-Z0-9\s]+" />
                @if(!agrement.valid && agrement.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_AGREMENT_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              @if((countryCode === 'FR' || countryCode === 'GP' || countryCode === 'MQ' || countryCode === 'RE')) {
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>SIRET</mat-label>
                <input matInput type="text" ngModel id="siret" name="siret" #siret="ngModel" maxlength="14"
                  required autocomplete="off" pattern="^\d{14}$" />
                @if(!siret.valid && siret.touched) {
                <mat-error>{{ 'REGISTRATION_VALID_SIRET_ERROR' | translate }}</mat-error>
                }
              </mat-form-field>
              }
            </div>
            }
          </fieldset>

          <!-- terms and consent -->
          <fieldset class="flex flex-col !leading-[2.4rem] sm:leading-normal border-none">
            <legend class="sr-only">Terms and consent</legend>
            <div>
              <mat-checkbox [(ngModel)]="trueInfo" id="trueInfo" name="trueInfo" required class="cursor-pointer"
                #trueInfoControl="ngModel" [color]="
                  trueInfoControl.errors && trueInfoControl.touched
                    ? 'warn'
                    : ''
                ">
              </mat-checkbox>
              <span class="font-renault-group-bold dsr-typescale-body-small-prominent" [ngClass]="{
                  'text-red-500':
                    trueInfoControl.errors && trueInfoControl.touched,
                }">{{ "REGISTRATION_TRUE_INFO" | translate }} &ast;</span>
            </div>
            <div class="">
              <mat-checkbox class="cursor-pointer" [(ngModel)]="profInfo" id="profInfo" name="profInfo" required
                #profInfoControl="ngModel" [color]="
                  profInfoControl.errors && profInfoControl.touched
                    ? 'warn'
                    : ''
                ">
              </mat-checkbox>
              <span class="font-renault-group-bold dsr-typescale-body-small-prominent" [ngClass]="{
                  'text-red-500':
                    profInfoControl.errors && profInfoControl.touched,
                }">
                {{
                ("PROFESSIONAL_TRUE_INFO_LABEL1" | translate) +
                (accountTypes[selectedAccountTypeIndex] | translate) +
                ". " +
                ("PROFESSIONAL_TRUE_INFO_LABEL2" | translate)
                }}
                &ast;</span>
            </div>
            <div>
              <mat-checkbox [(ngModel)]="termCond" id="termsConditions" name="termsConditions" required
                #termsConditionsControl="ngModel" class="cursor-pointer" [color]="
                  termsConditionsControl.errors && termsConditionsControl.touched ? 'warn' : ''">
              </mat-checkbox>
              <span class="!font-renault-group-bold dsr-typescale-body-small-prominent" [ngClass]="{ 'text-red-500': termsConditionsControl.errors &&
                termsConditionsControl.touched }">{{ "REGISTRATION_TC_AGREEMENT_LABEL" | translate }}
                <a target="_blank" [href]="termAndConditionLink"><span
                    class="cursor-pointer dsr-typescale-body-small-prominent decoration-dotted !border-dotted !border-b-2 dsr-typescale-body-small !font-bold!underline">{{ "REGISTRATION_TC" |
                    translate }}
                  </span></a>{{ "REGISTRATION_TC_PORTAL_LABEL" | translate }} &ast;
              </span>
            </div>

            <div class="w-full dsr-typescale-body-small-prominent">
              <span class="font-renault-group-bold dsr-typescale-body-small-prominent"
                [ngClass]="{ 'text-red-500': userConsent.errors && userConsent.touched }">
                {{ "USER_CONSENT_TEXT" | translate }}</span>
              <mat-radio-group aria-labelledby="consent-label" class="flex gap-[2rem]" name="consent" value="true"
                ngModel #userConsent="ngModel" required>
                <mat-radio-button disableRipple="true" value="yes" aria-label="I agree">
                  <span class="font-renault-group-bold dsr-typescale-body-small-prominent">
                    {{ "AGREE_TEXT" | translate }}</span></mat-radio-button>
                <mat-radio-button value="no" aria-label="I disagree">
                  <span class="font-renault-group-bold dsr-typescale-body-small-prominent">
                    {{ "DISAGREE_TEXT" | translate }}</span></mat-radio-button>
              </mat-radio-group>
            </div>
          </fieldset>

          <div class="flex flex-col sm:flex-row gap-[1.6rem] font-[600]">
            <button mat-flat-button class="" type="submit" (click)="submitRegistration()" [disabled]="registrationForm.invalid || sirenVatMismatch || !einvoiceAddressLineVerified || (showVatField &&
                  (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL3_FLEET ||
                    selectedAccountTypeIndex === this.ACCOUNT_TYPE_3_LABEL_AUTO_REPAIRER ||
                    (selectedAccountTypeIndex === this.ACCOUNT_TYPE_LABEL2_TECHNICAL_COLLEGE && registrationForm.value.paymentMethodForTechnical === 'yes')) &&
                  !vatVerified)" aria-label="Submit registration form">
              <span class="">{{ "CONFIRM_BUTTON" | translate }}</span>
            </button>
            <button mat-stroked-button color="primary" class="" type="reset" (click)="resetForm()"
              aria-label="Reset form"><span class="">{{ "CANCEL_BUTTON" | translate }}</span>
            </button>
            @if(hasError) {
            <div
              class="cell large-4 medium-3 small-12 gigya-error !text-red-500 bg-red-50 border border-red-200 rounded-md p-[5px]"
              role="alert" aria-live="assertive">{{ errorMessage }}</div>
            }
          </div>
        </form>
      </div>
      }
      <section class="flex flex-col gap-[0.6rem] mb-[12.8rem] w-full sm:max-w-[124.8rem]"
        aria-labelledby="privacy-heading">
        <h2 id="privacy-heading" class="dsr-typescale-body-small !uppercase">
          {{ "PERSONAL_INFO_HEADER" | translate }}</h2>
        <p class="dsr-typescale-body-small">{{ "PERSONAL_INFO_TEXT_1" | translate }}
          <a target="_blank" href="https://www.renault.fr/vos-droits.html"
            class="!border-dotted !border-b-2 dsr-typescale-body-small !font-bold" aria-label="Your rights information">
            https://www.renault.fr/vos-droits.html</a>
          {{ "PERSONAL_INFO_TEXT_2" | translate }}
          <a [href]="dataPrivacyDoc" target="_blank" rel="noopener noreferrer"
            class="!border-dotted !border-b-2 dsr-typescale-body-small !font-bold" aria-label="Personal data policy">
            {{ "PERSONAL_DATA_LINK" | translate }}</a>
        </p>
      </section>
    </div>
  </div>
</section>
} @else {
<section
  class="w-full h-[40rem] sm:h-[25rem] bg-[url('assets/images/banner.jpg')] text-white flex flex-col justify-center gap-20 text-start px-[7rem] sm:pl-[9.6rem] py-8 sm:py-0"
  role="status" aria-live="polite" aria-labelledby="success-heading">
  <div class="w-full sm:w-2/3">
    <h1 id="success-heading" class="dsr-typescale-title-medium text-white">{{ "REGISTRATION_SUCCESS" | translate }},
      {{ registrationForm.get("personnalData.firstName")!.value + " " +
      registrationForm.get("personnalData.lastName")!.value }}</h1>
  </div>
  <div class="w-full sm:w-2/3">
    <p class="dsr-typescale-title-small text-white">{{ "REGISTRATION_SUCCESS_2" | translate }}</p>
  </div>
</section>
<div class="flex flex-col sm:flex-row gap-[1.6rem] font-[600] text-[1.6rem] mt-[4rem] px-4 sm:pl-[9.6rem]">
  <button mat-flat-button color="primary" routerLink="/home" class="" aria-label="Return to home page">
    <dsr-icon name="home" size="1.6rem" color="var(--dsr-color-on-primary)" aria-hidden="true"></dsr-icon>
    <span class="!uppercase">{{ "REGISTRATION_SUCCESS_RETURN_HOME" | translate }}</span>
  </button>
  <button mat-flat-button class="" routerLink="/login" aria-label="Go to login page">
    <span class="!uppercase">{{ "FORM_LOGIN_BUTTON" | translate }}</span>
  </button>
</div>
}